// extracted by mini-css-extract-plugin
export var backdropBlur = "_ik-0";
export var contentCard = "_ik-5";
export var frame = "_ik-2";
export var image = "_ik-4";
export var imagePane = "_ik-3";
export var modal = "_ik-1";